import type { AxiosError } from 'axios';

import type { ErrorObjectArray } from '@liscio/api';

/** Normalize a thrown error (AxiosError or already-unwrapped body) into an
 *  ErrorObjectArray; returns { errors: [] } when no parseable body is present. */
export function toErrorObjectArray(error: unknown): ErrorObjectArray {
  const body =
    (error as AxiosError<ErrorObjectArray>)?.response?.data ??
    (error as ErrorObjectArray);
  return body && Array.isArray((body as ErrorObjectArray).errors)
    ? (body as ErrorObjectArray)
    : { errors: [] };
}
